import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import WorkedHours from '../WorkedHours/WorkedHours';
import BalanceDashboard from '../BalanceDashboard/BalanceDashboard';
import MiniCalendar from '../../calendar/MiniCalendar/MiniCalendar';
import DayEditor from '../../calendar/DayEditor/DayEditor';
import './DashboardTab.css';

const DashboardTab = () => {
  const { i18n } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(new Date());

  const formattedSelectedDate = selectedDate.toLocaleDateString(i18n.language, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  const handlePrevDay = () => {
    const prev = new Date(selectedDate);
    prev.setDate(prev.getDate() - 1);
    setSelectedDate(prev);
  };

  const handleNextDay = () => {
    const next = new Date(selectedDate);
    next.setDate(next.getDate() + 1);
    setSelectedDate(next);
  };

  return (
    <div className="dashboard-grid">
      <WorkedHours />
      <BalanceDashboard />
            
      <div className="dashboard-calendar">
        <MiniCalendar selectedDate={selectedDate} onDateSelect={setSelectedDate} />
      </div>
            
      <div className="dashboard-editor">
        <DayEditor 
          selectedDate={selectedDate} 
          formattedDate={formattedSelectedDate} 
          onPrev={handlePrevDay} 
          onNext={handleNextDay} 
        />
      </div>
    </div>
  );
};

export default DashboardTab;